import React from 'react';

const PrivacyPolicy = () => {
  return (
    <div>
        <div className="privacy-header">
        <div className="container">
            <div className="row">
                <div className="col-12">
                    <h1 className="display-5 fw-bold">Privacy Policy — Evolve Brands Pvt Ltd</h1>
                    <p className="lead">DPDP 2023 Compliant</p>
                    <div className="d-flex justify-content-between mt-3">
                        <p className="mb-0"><strong>Effective Date:</strong> 17th June 2025</p>
                        <p className="mb-0"><strong>Last Updated:</strong> 17th June 2025</p>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div className="container">
        <div className="row">
            <div className="col-12">
                <section id="introduction">
                    <h2 className="section-title">1. Introduction</h2>
                    <p>At Evolve Brands Pvt. Ltd. ("EBPL", "we", "us", "our"), your privacy is of utmost importance. This Privacy Policy explains how we collect, process, store, share, and safeguard your personal data, in accordance with the Digital Personal Data Protection Act, 2023 (DPDP Act, India) and other applicable laws.</p>
                    <div className="highlight">
                        <p>By accessing, registering, or using our mobile applications, website, or loyalty reward services ("Services"), you acknowledge that you have read, understood, and consented to the practices described in this Privacy Policy.</p>
                    </div>
                </section>

                <section id="definitions">
                    <h2 className="section-title">2. Definitions</h2>
                    <div className="row">
                        <div className="col-md-6">
                            <ul className="data-list">
                                <li><strong>Personal Data:</strong> Any data about an individual who is identifiable by such data.</li>
                                <li><strong>Data Principal:</strong> You, the individual whose data is being collected.</li>
                                <li><strong>Data Fiduciary:</strong> Evolve Brands Pvt Ltd, the entity determining the purpose and means of processing personal data.</li>
                            </ul>
                        </div>
                        <div className="col-md-6">
                            <ul className="data-list">
                                <li><strong>Data Processor:</strong> Any third party processing data on behalf of EBPL.</li>
                                <li><strong>Consent:</strong> A freely given, specific, informed, and unambiguous agreement for processing personal data.</li>
                            </ul>
                        </div>
                    </div>
                </section>

                <section id="applicability">
                    <h2 className="section-title">3. Applicability</h2>
                    <p>This policy applies to:</p>
                    <ul className="data-list">
                        <li>All users of our services in India.</li>
                        <li>Personal data collected via our mobile apps, website, loyalty platform, or any offline collection method.</li>
                        <li>Processing activities done by EBPL or authorized third parties.</li>
                    </ul>
                </section>

                <section id="data-we-collect">
                    <h2 className="section-title">4. Data We Collect</h2>
                    
                    <h4>4.1 Personal Data You Provide</h4>
                    <p>We may collect and process:</p>
                    <div className="row">
                        <div className="col-md-6">
                            <ul className="data-list">
                                <li>Full Name</li>
                                <li>Date of Birth</li>
                                <li>Gender</li>
                                <li>Email Address</li>
                                <li>Mobile Number</li>
                                <li>Residential/Business Address</li>
                            </ul>
                        </div>
                        <div className="col-md-6">
                            <ul className="data-list">
                                <li>Company Name and Position</li>
                                <li>PAN / Aadhaar (only where legally permissible)</li>
                                <li>Bank Account / UPI details (for loyalty payouts)</li>
                                <li>Customer Interaction Data (purchase, participation, survey, etc.)</li>
                                <li>Your consent records</li>
                            </ul>
                        </div>
                    </div>
                    
                    <h4 className="mt-4">4.2 Personal Data of End Users (If applicable)</h4>
                    <p>If you provide us with your customer data (for example, during loyalty program management), we may collect:</p>
                    <ul className="data-list">
                        <li>Customer Name</li>
                        <li>Contact Details</li>
                        <li>Purchase or Transaction History</li>
                        <li>Loyalty Points Data</li>
                    </ul>
                    
                    <h4 className="mt-4">4.3 Data Collected Automatically</h4>
                    <div className="row">
                        <div className="col-md-6">
                            <ul className="data-list">
                                <li>IP Address</li>
                                <li>Device Information</li>
                                <li>Browser Type</li>
                            </ul>
                        </div>
                        <div className="col-md-6">
                            <ul className="data-list">
                                <li>Cookies and Tracking Data</li>
                                <li>Location Data</li>
                                <li>App Usage Behaviour</li>
                                <li>Log Files</li>
                            </ul>
                        </div>
                    </div>
                </section>

                <section id="purpose">
                    <h2 className="section-title">5. Purpose of Processing</h2>
                    <p>We collect and process your data for:</p>
                    <div className="row">
                        <div className="col-md-6">
                            <ul className="data-list">
                                <li>Registration, onboarding, and identity verification.</li>
                                <li>Managing your participation in loyalty programs.</li>
                                <li>Processing loyalty points, redemptions, and rewards.</li>
                                <li>Customer support and grievance handling.</li>
                            </ul>
                        </div>
                        <div className="col-md-6">
                            <ul className="data-list">
                                <li>Transaction monitoring and fraud prevention.</li>
                                <li>Business analytics, reporting, and platform improvements.</li>
                                <li>Legal and regulatory compliance.</li>
                                <li>Sending transactional communications, promotional messages, and service updates.</li>
                            </ul>
                        </div>
                    </div>
                </section>

                <section id="legal-basis">
                    <h2 className="section-title">6. Legal Basis for Processing</h2>
                    <p>Under DPDP Act 2023, we collect and process data on the following grounds:</p>
                    <ul className="data-list">
                        <li><strong>Consent:</strong> For most data processing activities.</li>
                        <li><strong>Performance of Contract:</strong> When necessary to deliver services requested.</li>
                        <li><strong>Legal Obligation:</strong> Where mandated by law or government authority.</li>
                        <li><strong>Legitimate Interest:</strong> For internal operations, fraud detection, or legal defence.</li>
                    </ul>
                </section>

                <section id="consent">
                    <h2 className="section-title">7. Consent Management</h2>
                    <ul className="data-list">
                        <li>We obtain your explicit, informed, and voluntary consent before collecting personal data.</li>
                        <li>You may withdraw your consent anytime by contacting us (see Section 14). Upon withdrawal, we may be unable to provide certain services.</li>
                    </ul>
                </section>

                <section id="children">
                    <h2 className="section-title">8. Data of Children</h2>
                    <ul className="data-list">
                        <li>We do not knowingly collect personal data of individuals under the age of 18 years without verified parental consent.</li>
                        <li>If you are under 18, do not provide personal data unless parental or guardian consent has been obtained.</li>
                    </ul>
                </section>

                <section id="retention">
                    <h2 className="section-title">9. Data Retention</h2>
                    <ul className="data-list">
                        <li>We retain personal data only as long as necessary to fulfil the purpose of collection, comply with legal obligations, and resolve disputes.</li>
                        <li>Upon purpose completion or withdrawal of consent, your data will be deleted, anonymized, or archived as per retention policy.</li>
                    </ul>
                </section>

                <section id="rights">
                    <h2 className="section-title">10. Your Rights (Data Principal Rights)</h2>
                    <p>Under the DPDP Act, you have the right to:</p>
                    <div className="row">
                        <div className="col-md-6">
                            <ul className="data-list">
                                <li><strong>Access:</strong> Know what personal data we process about you.</li>
                                <li><strong>Correction:</strong> Request correction of inaccurate or outdated data.</li>
                            </ul>
                        </div>
                        <div className="col-md-6">
                            <ul className="data-list">
                                <li><strong>Erasure:</strong> Request deletion after purpose is fulfilled.</li>
                                <li><strong>Grievance Redressal:</strong> Lodge complaints and seek timely resolution.</li>
                                <li><strong>Nominate:</strong> Appoint a nominee to exercise your rights in case of incapacity.</li>
                            </ul>
                        </div>
                    </div>
                    <div className="highlight mt-3">
                        <p>You may exercise these rights by contacting our Grievance Officer (see Section 14).</p>
                    </div>
                </section>

                <section id="sharing">
                    <h2 className="section-title">11. Data Sharing and Disclosure</h2>
                    <p>We may share personal data only:</p>
                    <ul className="data-list">
                        <li>With authorized third-party service providers for payment processing, IT support, cloud storage, analytics, and customer support.</li>
                        <li>With affiliates and business partners under binding agreements ensuring data protection.</li>
                        <li>As required by law, government agencies, or regulatory authorities.</li>
                        <li>During corporate restructuring, merger, or acquisition, where data may be transferred with notification.</li>
                    </ul>
                    <div className="alert alert-info mt-3">
                        <strong>We DO NOT sell your personal data to any third party.</strong>
                    </div>
                </section>

                <section id="cross-border">
                    <h2 className="section-title">12. Cross-Border Data Transfer</h2>
                    <p>We may transfer your personal data outside India to jurisdictions with adequate data protection as notified by the Indian government, subject to applicable laws. All such transfers will be subject to appropriate contractual safeguards ensuring protection of your data.</p>
                </section>

                <section id="security">
                    <h2 className="section-title">13. Data Security Measures</h2>
                    <p>We implement appropriate technical, organizational, and security measures including:</p>
                    <div className="row">
                        <div className="col-md-6">
                            <ul className="data-list">
                                <li>Encryption (TLS) for data transmission</li>
                                <li>Access control & authentication</li>
                                <li>Secure cloud storage</li>
                            </ul>
                        </div>
                        <div className="col-md-6">
                            <ul className="data-list">
                                <li>Employee confidentiality agreements</li>
                                <li>Periodic security audits</li>
                                <li>Breach response plan</li>
                            </ul>
                        </div>
                    </div>
                    <div className="highlight mt-3">
                        <p>However, no system can be 100% secure. In case of any data breach, we shall notify affected data principals and authorities as mandated.</p>
                    </div>
                </section>

                <section id="grievance">
                    <h2 className="section-title">14. Grievance Officer</h2>
                    <p>As per DPDP Act 2023, we have appointed a Grievance Officer:</p>
                    <div className="card contact-card mb-4">
                        <div className="card-body">
                            <h5 className="card-title">Seema Motwani</h5>
                            <h6 className="card-subtitle mb-2 text-muted">Associate Vice President</h6>
                            <p className="card-text"><strong>Email:</strong> <a href="mailto:Seemam@evolvebrands.com">Seemam@evolvebrands.com</a></p>
                            <p className="card-text"><strong>Response Time:</strong> Within 7 days of receiving the grievance</p>
                        </div>
                    </div>
                </section>

                <section id="automated">
                    <h2 className="section-title">15. Automated Decision Making & Profiling</h2>
                    <p>We do not use personal data for fully automated decision-making that affects your legal or personal rights. Any profiling is purely for service improvement or personalised offers, with your consent.</p>
                </section>

                <section id="updates">
                    <h2 className="section-title">16. Updates to This Policy</h2>
                    <p>We may update this policy from time to time. Changes will be notified through:</p>
                    <ul className="data-list">
                        <li>Website announcements</li>
                        <li>In-app notifications</li>
                        <li>Email communications</li>
                    </ul>
                    <div className="highlight mt-3">
                        <p>You are requested to review the policy periodically. Continued use after updates implies your acceptance.</p>
                    </div>
                </section>

                <section id="contact">
                    <h2 className="section-title">17. Contact Information</h2>
                    <p>For any concerns or queries regarding this policy or data protection practices:</p>
                    <div className="card mb-4">
                        <div className="card-body">
                            <h5 className="card-title">Evolve Brands Pvt Ltd</h5>
                            <p className="card-text">
                                <strong>Registered Office:</strong><br />
                                4th Floor, G S Tower, Plot no. 112,<br />
                                Udyog Vihar Phase 1, Udyog Vihar,<br />
                                Sector 20, Gurugram, Haryana 122016
                            </p>
                            <p className="card-text"><strong>Email:</strong> <a href="mailto:info@evolvebrands.com">info@evolvebrands.com</a></p>
                        </div>
                    </div>
                </section>
            </div>
        </div>
    </div>
    </div>
  );
};

export default PrivacyPolicy;